/* Reusable rail navigation; works with Shopify section re-rendering. */
(() => {
  function mount(scope) {
    scope.querySelectorAll('.gg-v9-rail:not([data-gg-rail-ready])').forEach(rail => {
      rail.dataset.ggRailReady = '1';
      const track=rail.querySelector('[data-gg-rail-track]');
      const prev=rail.querySelector('[data-gg-rail-prev]');
      const next=rail.querySelector('[data-gg-rail-next]');
      if(!track||!prev||!next)return;
      const update=()=>{prev.disabled=track.scrollLeft<=3;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
      const step=()=>{const item=track.firstElementChild;if(!item)return track.clientWidth;const gap=parseFloat(getComputedStyle(track).columnGap)||10;return item.getBoundingClientRect().width+gap;};
      prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
      next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
      track.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update);
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document));else mount(document);
  document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
